

export default function Footer() {
  return (
    <footer>
        <p>O. Sharpe • © 2023</p>
    </footer>
  );
};